import { $ } from 'jquery'
import 'slick-carousel/slick/slick.min.js';

(function ($) {
    $(function () {

        if ($('.site-homepage__hero-slider').length > 0) {
            var $featuredSlider = $('.site-homepage__hero-slider');
            $featuredSlider.on('init', function (event, slick) {
                updateSlideAttributes($featuredSlider.find('.slick-slide .site-homepage__hero-slide--container'));
                $featuredSlider.find('.site-cta-button').attr('aria-hidden', 'true');
            });

            var $slider = $featuredSlider.slick({
                mobileFirst: true,
                slide: 'div.site-homepage__hero-slide',
                dots: true,
                speed: 1000,
                fade: false,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 8000,
                accessibility: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            dots: false,
                            arrows: true
                        }
                    }
                ]
            });

            // add a title to the slick-track element for accessibility.
            $slider.find('.slick-track').attr({
                role: 'group',
                title: 'hero slider'
            });
        }

        $('.slick-slider:not(.slick-dotted)').each(function () {
            updateSlideAttributes($(this).find('.slick-slide .image-wrapper'));
        });

        function updateSlideAttributes(selector) {
            selector.each(function () {
                var $slide = $(this).parents('.slick-slide');
                if ($slide.attr('aria-describedby') !== undefined) { // ignore extra/cloned slides
                    $(this).attr('id', $slide.attr('aria-describedby'));

                }

            });
        }

        //upcoming events module
        var $eventsGrid = $('.js-events-wrapper');
        if ($eventsGrid.length > 0) {
            var sliderAttributes = $eventsGrid.data('slider-settings');
            $eventsGrid.on('init', function (event, slick) {
                updateSlideAttributes($eventsGrid.find('.event__item'));
            });

            $eventsGrid.slick(sliderAttributes);

            // add a title to the slick-track element for accessibility.
            $eventsGrid.find('.slick-track').attr('title', 'events slider');
        }

        var $isbnCarousel = $('.isbn-carousel');
        if ($isbnCarousel.length > 0) {
            $isbnCarousel.each(function () {
                if ($isbnCarousel.find('.slick-dots li').length > 0) {
                    $isbnCarousel.find('.slick-dots li').each(function () {
                        var val = $(this).attr('id');
                        $(this).attr('aria-controls', val);
                        $(this).attr('role', 'tab');
                        if ($(this).attr('aria-hidden') == 'true') {
                            $(this).find('button').attr('tabindex', '-1');
                        }
                        $(this).removeAttr('aria-selected');
                    });
                }
            });

        }

		$(".slick-slider").find(".slick-track").each(function () {
			$(this).attr("aria-label", "isbn-carousel");
			$(this).attr("title", "isbn-carousel");
		});

    });
})(jQuery);
